import { Component, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import IntroOverlay from "./components/IntroOverlay";
import ContactForm from "./components/ContactForm";
import PrivacyPage from "./pages/PrivacyPage";
import PatternHoverEffect from "./components/PatternHoverEffect";
import BrandLogo from "./components/BrandLogo";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page">
          <main className="error-shell">
            <section className="form-card form-success">
              <h1 className="success-title">Corte Gesya</h1>
              <p className="success-text">Si è verificato un errore. Ricarica la pagina.</p>
            </section>
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}

function Landing() {
  const [introDone, setIntroDone] = useState(false);
  const [successWave, setSuccessWave] = useState(false);

  const playSuccessWave = () =>
    new Promise((resolve) => {
      setSuccessWave(true);
      window.setTimeout(() => {
        setSuccessWave(false);
        resolve();
      }, 3400);
    });

  return (
    <div
      className={`page${introDone ? " page-ready" : ""}${successWave ? " success-wave-active" : ""}`}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL || ""}/cream-pattern-seamless-v2.svg)`,
      }}
    >
      {!introDone && <IntroOverlay onFinish={() => setIntroDone(true)} />}
      {introDone && <PatternHoverEffect />}

      {successWave && (
        <div
          className="success-wave"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL || ""}/cream-pattern-seamless-hover-v2.svg)`,
          }}
          aria-hidden="true"
        />
      )}

      <main className="landing-shell">
        <section className="brand-panel" aria-label="Corte Gesya">
          <BrandLogo className="site-logo" />
        </section>

        <section className="form-panel">
          <ContactForm onSuccessAnimation={playSuccessWave} />
        </section>

        <div className="contact-block">
          <a href="mailto:info@cortegesya.com">INFO@CORTEGESYA.COM</a>
          <a href="https://cortegesya.com">CORTEGESYA.COM</a>
        </div>
      </main>

      <footer className="site-footer">
        <span>
          Un&apos;iniziativa di{" "}
          <a href="https://www.immobiliareciurriero.it/" target="_blank" rel="noopener noreferrer">
            Immobiliare Ciurriero
          </a>
        </span>
        <span>
          Digital Partner{" "}
          <a href="https://wearealbero.com" target="_blank" rel="noopener noreferrer">
            We Are Albero
          </a>
        </span>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
